import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { folderTypes } from "@redotech/redo-views-common/folders";
import { ReturnView } from "@redotech/redo-views-common/views";
import { ReactNode, createContext, memo } from "react";
import { useViewsAndFolders } from "../hooks/use-views-and-folders";

export const ClaimViewsContext = createContext<
  { teamViews?: ReturnView[]; folders?: folderTypes["claims"][] } | undefined
>(undefined);

export const ReloadClaimViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const ClaimViewsProvider = memo(function ClaimViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useViewsAndFolders<
    ReturnView,
    folderTypes["claims"],
    ReturnTypeEnum.CLAIM
  >(
    ReturnTypeEnum.CLAIM,
    ReturnsAndClaimsPermissions.MANAGE_PACKAGE_PROTECTION_CLAIM,
  );

  return (
    <ClaimViewsContext.Provider value={{ teamViews: views, folders }}>
      <ReloadClaimViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadClaimViewsContext.Provider>
    </ClaimViewsContext.Provider>
  );
});
